import React, { useContext, useCallback } from 'react';

import MyFleetContext from '../context';

import {
  StyledCard,
  StyledHeader,
  StyledSidebar,
  StyledContent,
  StyledAssignWrapper,
  StyledCardWrapper,
} from 'modules/assignment-cards/styled';

import { VehicleInfo, JourneysInfo } from 'modules/assignment-cards/components';
import HeaderInfo from '../../assignment-cards/components/DriverHeaderInfo';

const DriverCard = ({
  id,
  vertical,
  assignActionComponent: AssignActionComponent = null,
  allowRemove,
}) => {
  const {
    fetchingJourneys,
    journeysByDriver = {},
    myFleetObject,
    removeCard,
  } = useContext(MyFleetContext);

  const fleetItem = myFleetObject[id] || {};
  const { vehicle, trailer } = fleetItem;
  const driverId = fleetItem?.id;
  const driverJourneys = journeysByDriver[driverId] || [];
  const vehicleids = [(vehicle || {}).id, (trailer || {}).id];

  const vehicleModel = {
    ...fleetItem,
    vehicle: vehicle && trailer ? trailer : vehicle,
  };

  const handleRemove = useCallback(() => {
    removeCard(id);
  }, [removeCard, id]);

  return (
    <StyledCardWrapper vertical={vertical}>
      <StyledCard data-testid="myfleet_card" vertical={vertical}>
        <StyledHeader>
          <HeaderInfo
            driver={fleetItem}
            driverJourneys={driverJourneys}
            fetchingJourneys={fetchingJourneys}
            onRemoveClick={handleRemove}
            allowRemove={allowRemove}
          />
        </StyledHeader>
        <StyledSidebar>
          <VehicleInfo model={vehicleModel} />
        </StyledSidebar>
        <StyledContent vertical={vertical}>
          {!!AssignActionComponent && (
            <StyledAssignWrapper>
              <AssignActionComponent driverId={driverId} vehicleIds={vehicleids} />
            </StyledAssignWrapper>
          )}
          <JourneysInfo
            id={id}
            fetching={fetchingJourneys}
            journeys={(journeysByDriver || {})[driverId]}
          />
        </StyledContent>
      </StyledCard>
    </StyledCardWrapper>
  );
};

export default DriverCard;
